/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import ModalPrint from "../ModalPrint";
import Notif from "../../../Components/Notif";
import Patient from "../../../Server/Patient";
import Label from '../../../Components/Control/Label';
import Check from '../../../Components/Control/Check';
import MyComponent from '../../../Components/MyComponent';
import Date from '../../../Components/Control/Date';
import {OrganizationIrradiateRequest, SectionIrradiateRequest} from '../../../Server/IrradiateRequest';
import InputButton from '../../../Components/Control/InputButton';
import Select from "../../../Components/Control/Select";

class ModalIrradiateRequest extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            error: null,
            loading: null,
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            patientFileCode: React.createRef(),
            predicteInjectionDateTime: React.createRef(),
            probablyDiagnosticStr: React.createRef(),
            peyvandOlozhinc: React.createRef(),
            sandron: React.createRef(),
            faravardeh: React.createRef(),
            darman: React.createRef(),
            platelet: React.createRef(),
            vahed: React.createRef(),
            nozad: React.createRef(),
            peyvandOrgan: React.createRef(),
            tazrig: React.createRef(),
            bimari: React.createRef(),
            lanfom: React.createRef(),
            anemy: React.createRef(),
            docterId: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            printLabel: React.createRef(),
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        patientFileCode: x => Boolean(x) || 'شماره پرونده بیمار وارد نشده است.',
        predicteInjectionDateTime: x => Boolean(x) || 'تاریخ تزریق وارد نشده است.',
        probablyDiagnosticStr: x => Boolean(x) || 'تشخیص احتمالی وارد نشده است.',
        docterId: x => Boolean(x?.[0]?.id) || 'نام پزشک انتخاب نشده است.'
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            state.patientFileInfo !== nextState.patientFileInfo ||
            props.base.normRequestFormPrintOnSubmit !== nextProps.base.normRequestFormPrintOnSubmit;
    }

    render() {
        const {state, props} = this;
        const readOnly = state.action === ModalAction.VIEW;
        const age = state?.patientFileInfo?.patientBirthDate ? moment().diff(moment(state?.patientFileInfo?.patientBirthDate, 'jYYYY-jMM-jDD'), 'year') : null;
        const products = [];
        const doctors = [
            {id: '', text: '...'},
            ...props.base.doctors
        ];

        if (state.data?.sectionRadiatedRequestForm_ProductsVM)
            for (let i = 0; i < state.data?.sectionRadiatedRequestForm_ProductsVM.length; i += 2) {
                products.push([
                    state.data?.sectionRadiatedRequestForm_ProductsVM[i] || {},
                    state.data?.sectionRadiatedRequestForm_ProductsVM[i + 1] || {}
                ]);
            }

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalIrradiateRequest'}
                   size={'large'}
                   title={'فرم درخواست خون اشعه‌دیده'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <table>
                        <tbody>
                        <tr>
                            <td colSpan={2}>
                                <div className={'dis-f'}>
                                    <div className={'flex ali-c'} style={{fontSize: 13, fontWeight: 500}}>فرم درخواست خون اشعه‌دیده</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td><InputButton ref={this.ref.patientFileCode} className={'pad-4'} label={'شماره پرونده'} readOnly={readOnly} value={state?.fields?.patientFileCode} validation={this.validations.patientFileCode} onChange={this.setField.bind(this, 'patientFileCode')} onEnter={this.patientFileCodeSubmitHandler.bind(this)} buttonTitle={'جستجو'} onButtonClick={this.patientFileCodeSubmitHandler.bind(this)}/></td>
                            {/*<td><Input ref={this.ref.patientFileCode} className={'pad-4'} label={'شماره پرونده'} readOnly={readOnly} value={state?.fields?.patientFileCode} validation={this.validations.patientFileCode} onChange={this.setField.bind(this, 'patientFileCode')} onEnter={this.patientFileCodeSubmitHandler.bind(this)} onBlur={this.patientFileCodeSubmitHandler.bind(this)}/></td>*/}
                            <td><Input className={'pad-4'} label={'نام و نام خانوادگی بیمار'} readOnly={true} value={state.patientFileInfo?.patientFullName}/></td>
                        </tr>
                        <tr>
                            <td><Input className={'pad-4'} label={'گروه خون بیمار'} direction={'ltr'} align={'center'} readOnly={true} value={state.patientFileInfo?.patientBloodGroupStr}/></td>
                            <td><Input className={'pad-4'} label={'سن بیمار'} readOnly={true} value={age}/></td>
                        </tr>
                        <tr>
                            <td><Date ref={this.ref.predicteInjectionDateTime} className={'pad-4'} label={'تاریخ پیش بینی شده جهت تزریق'} readOnly={readOnly} value={state?.fields?.predicteInjectionDateTime} validation={this.validations.predicteInjectionDateTime} min={moment().startOf('jDay')} onChange={this.setField.bind(this, 'predicteInjectionDateTime')}/></td>
                            <td><Input ref={this.ref.probablyDiagnosticStr} className={'pad-4'} label={'تشخیص احتمالی'} readOnly={readOnly} value={state?.fields?.probablyDiagnosticStr} validation={this.validations.probablyDiagnosticStr} onChange={this.setField.bind(this, 'probablyDiagnosticStr')}/></td>
                        </tr>
                        <tr>
                            <td colSpan={2}><Label>لطفا علت درخواست خون و فرآورده اشعه‌دیده را مشخص کنید:</Label></td>
                        </tr>
                        <tr>
                            <td><Check className={'pad-4'} label={'پیوند الوژینیک و یا اتولوگ سلول‌های پیش ساز خونی'} readOnly={readOnly} checked={Boolean(state?.fields?.peyvandOlozhinc)} onChange={this.setField.bind(this, 'peyvandOlozhinc')}/></td>
                            <td><Check ref={this.ref.nozad} className={'pad-4'} label={'نوزاد با وزن پایین'} readOnly={readOnly} checked={Boolean(state?.fields?.nozad)} onChange={this.setField.bind(this, 'nozad')}/></td>
                        </tr>
                        <tr>
                            <td><Check ref={this.ref.sandron} className={'pad-4'} label={'سندرن نقص ایمنی مادرزادی'} readOnly={readOnly} checked={Boolean(state?.fields?.sandron)} onChange={this.setField.bind(this, 'sandron')}/></td>
                            <td><Check ref={this.ref.peyvandOrgan} className={'pad-4'} label={'پیوند ارگان‌های توپر'} readOnly={readOnly} checked={Boolean(state?.fields?.peyvandOrgan)} onChange={this.setField.bind(this, 'peyvandOrgan')}/></td>
                        </tr>
                        <tr>
                            <td><Check ref={this.ref.faravardeh} className={'pad-4'} label={'فرآورده‌های تهیه شده از اهداکنندگان مستقیم'} readOnly={readOnly} checked={Boolean(state?.fields?.faravardeh)} onChange={this.setField.bind(this, 'faravardeh')}/></td>
                            <td><Check ref={this.ref.tazrig} className={'pad-4'} label={'تزریق خون داخل رحمی'} readOnly={readOnly} checked={Boolean(state?.fields?.tazrig)} onChange={this.setField.bind(this, 'tazrig')}/></td>
                        </tr>
                        <tr>
                            <td><Check ref={this.ref.darman} className={'pad-4'} label={'درمان سرکوبگر سیستم ایمنی در بیماران سرطانی'} readOnly={readOnly} checked={Boolean(state?.fields?.darman)} onChange={this.setField.bind(this, 'darman')}/></td>
                            <td><Check ref={this.ref.bimari} className={'pad-4'} label={'بیماری هوچکین'} readOnly={readOnly} checked={Boolean(state?.fields?.bimari)} onChange={this.setField.bind(this, 'bimari')}/></td>
                        </tr>
                        <tr>
                            <td><Check ref={this.ref.platelet} className={'pad-4'} label={'پلاکت‌های فریزیس با HLA سازگار'} readOnly={readOnly} checked={Boolean(state?.fields?.platelet)} onChange={this.setField.bind(this, 'platelet')}/></td>
                            <td><Check ref={this.ref.lanfom} className={'pad-4'} label={'لنفوم / لوسمی'} readOnly={readOnly} checked={Boolean(state?.fields?.lanfom)} onChange={this.setField.bind(this, 'lanfom')}/></td>
                        </tr>
                        <tr>
                            <td><Check ref={this.ref.vahed} className={'pad-4'} label={'واحد‌های خون اهدایی خویشاوندان درجه یک یا دو'} readOnly={readOnly} checked={Boolean(state?.fields?.vahed)} onChange={this.setField.bind(this, 'vahed')}/></td>
                            <td><Check ref={this.ref.anemy} className={'pad-4'} label={'آنمی اپلاستیک'} readOnly={readOnly} checked={Boolean(state?.fields?.anemy)} onChange={this.setField.bind(this, 'anemy')}/></td>
                        </tr>
                        <tr>
                            <td colSpan={2}><Select ref={this.ref.docterId} className={'pad-4'} label={'نام پزشک'} readOnly={readOnly} options={doctors} value={state?.fields?.docterId} validation={this.validations.docterId} onChange={this.setField.bind(this, 'docterId')}/></td>
                        </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                        {products.length > 0 ? <React.Fragment>
                            <tr className={'b '}>
                                <td className={'bl'}><Label style={{lineHeight: '30px'}}>شماره فرآورده</Label></td>
                                <td className={'bl'}><Label style={{lineHeight: '30px'}}>گروه خونی فرآورده</Label></td>
                                <td className={'bl'}><Label style={{lineHeight: '30px'}}>شماره فرآورده</Label></td>
                                <td><Label style={{lineHeight: '30px'}}>گروه خونی فرآورده</Label></td>
                            </tr>
                            {products.map(items => <tr className={'bl br bb'}>
                                <td className={'bl'}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[0].productNumber}</Label></td>
                                <td className={'bl'}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[0].productBloodGroupStr}</Label></td>
                                <td className={'bl'}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[1].productNumber}</Label></td>
                                <td className={''}><Label style={{lineHeight: '25px', textAlign: 'center'}}>{items[1].productBloodGroupStr}</Label></td>
                            </tr>)}
                        </React.Fragment> : null}
                        </tbody>
                    </table>
                </ModalContent>
                <ModalControls>
                    {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش درخواست</Button>}
                    {state.action === ModalAction.INSERT && <Button refer={this.ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت درخواست</Button>}
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={this.ref.modalPrint}/>
        </React.Fragment>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'patientFileCode':
                this.setState({patientFileInfo: undefined});
                break;
            default:
        }
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            if (!state.patientFileInfo) {
                new Notif({message: 'شماره پرونده معتبر نمی باشد.', theme: 'error'}).show();
                return;
            }
            ref.insert.current.loading();
            this.setState({error: null});

            SectionIrradiateRequest.insert({
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId,
                predicteInjectionDateTime: state.fields?.predicteInjectionDateTime?.format() || null,
                probablyDiagnosticStr: state.fields?.probablyDiagnosticStr,
                peyvandOlozhinc: state.fields?.peyvandOlozhinc || false,
                sandron: state.fields?.sandron || false,
                faravardeh: state.fields?.faravardeh || false,
                darman: state.fields?.darman || false,
                platelet: state.fields?.platelet || false,
                vahed: state.fields?.vahed || false,
                nozad: state.fields?.nozad || false,
                peyvandOrgan: state.fields?.peyvandOrgan || false,
                tazrig: state.fields?.tazrig || false,
                bimari: state.fields?.bimari || false,
                lanfom: state.fields?.lanfom || false,
                anemy: state.fields?.anemy || false,
                docterId: state.fields?.docterId?.[0]?.id
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();

                ref.insert.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                patientFileInfo: data.patientFileInfo,
                error: null
            });
        } else if (action === ModalAction.UPDATE || action === ModalAction.VIEW) {
            this.setState({
                data,
                action,
                fields: {},
                error: null,
                loading: 'در حال دریافت اطلاعات درخواست'
            });

            if (data?.sectionRequestId)
                SectionIrradiateRequest.data({sectionRequestId: data?.sectionRequestId})
                    .then(data => {
                        this.setState({
                            data,
                            fields: {
                                patientFileCode: data?.patientFileCode,
                                predicteInjectionDateTime: data?.predicteInjectionDateTime ? moment(data?.predicteInjectionDateTime) : null,
                                probablyDiagnosticStr: data?.probablyDiagnosticStr,
                                peyvandOlozhinc: data?.peyvandOlozhinc || false,
                                sandron: data?.sandron || false,
                                faravardeh: data?.faravardeh || false,
                                darman: data?.darman || false,
                                platelet: data?.platelet || false,
                                vahed: data?.vahed || false,
                                nozad: data?.nozad || false,
                                peyvandOrgan: data?.peyvandOrgan || false,
                                tazrig: data?.tazrig || false,
                                bimari: data?.bimari || false,
                                lanfom: data?.lanfom || false,
                                anemy: data?.anemy || false,
                                docterId: [{id: data?.docterId}]
                            },
                            patientFileInfo: {
                                patientFileCodeId: data?.patientFileCodeId,
                                patientFullName: `${data?.patientFirstName} ${data?.patientLastName}`,
                                patientBloodGroupStr: data?.patientBloodGroupStr,
                                patientBirthDate: data?.patientBirthDate
                            },
                            loading: null
                        });
                    })
                    .catch(message => {
                        this.setState({
                            error: message,
                            loading: null
                        });
                    });

            if (data?.hospitalRequestId)
                OrganizationIrradiateRequest.data({hospitalRequestId: data?.hospitalRequestId})
                    .then(data => {
                        this.setState({
                            data,
                            fields: {
                                predicteInjectionDateTime: data?.predicteInjectionDateTime ? moment(data?.predicteInjectionDateTime) : null,
                                probablyDiagnosticStr: data?.probablyDiagnosticStr,
                                peyvandOlozhinc: data?.peyvandOlozhinc || false,
                                sandron: data?.sandron || false,
                                faravardeh: data?.faravardeh || false,
                                darman: data?.darman || false,
                                platelet: data?.platelet || false,
                                vahed: data?.vahed || false,
                                nozad: data?.nozad || false,
                                peyvandOrgan: data?.peyvandOrgan || false,
                                tazrig: data?.tazrig || false,
                                bimari: data?.bimari || false,
                                lanfom: data?.lanfom || false,
                                anemy: data?.anemy || false,
                                docterId: [{id:data?.docterId}]
                            },
                            loading: null
                        });
                    })
                    .catch(message => {
                        this.setState({
                            error: message,
                            loading: null
                        });
                    });
        }

        this.ref.modal.current.open()
            .then(_ => {
                if (action === ModalAction.INSERT) {
                    this.ref.patientFileCode.current.focus();
                }
            });
    }

    patientFileCodeSubmitHandler(value) {
        if (!value) {
            this.setState({patientFileInfo: undefined});
        }

        if (value) {
            this.setState({
                patientFileInfo: undefined,
                loading: 'در حال دریافت پرونده بیمار'
            });

            Patient.data({
                patientFileCode: value
            })
                .then(data => {
                    this.setState({
                        patientFileInfo: data,
                        loading: false
                    });
                })
                .catch(message => {
                    this.setState({
                        patientFileInfo: undefined,
                        loading: false,
                    }, _ => {
                        new Notif({message, theme: 'error'}).show();
                    });
                });
        }
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            SectionIrradiateRequest.update({
                sectionRadiatedRequestId: state.data?.sectionRadiatedRequestId,
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId,
                predicteInjectionDateTime: state.fields?.predicteInjectionDateTime?.format() || null,
                probablyDiagnosticStr: state.fields?.probablyDiagnosticStr,
                peyvandOlozhinc: state.fields?.peyvandOlozhinc || false,
                sandron: state.fields?.sandron || false,
                faravardeh: state.fields?.faravardeh || false,
                darman: state.fields?.darman || false,
                platelet: state.fields?.platelet || false,
                vahed: state.fields?.vahed || false,
                nozad: state.fields?.nozad || false,
                peyvandOrgan: state.fields?.peyvandOrgan || false,
                tazrig: state.fields?.tazrig || false,
                bimari: state.fields?.bimari || false,
                lanfom: state.fields?.lanfom || false,
                anemy: state.fields?.anemy || false,
                docterId: state.fields?.docterId?.[0]?.id
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.update.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);

                new Notif({message, theme: 'error'}).show();

                this.setState({error: message});
            });
        }
    }

    validate() {
        const {ref} = this;
        const validate = Tool.validate(ref.patientFileCode,
            ref.predicteInjectionDateTime,
            ref.probablyDiagnosticStr,
            ref.docterId
        );

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

export default connect(mapStateToProps)(ModalIrradiateRequest);